import { Typography, Skeleton } from "@fullscript/aviary-web";
import { useState } from "react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Accordion } from "@aviary";
import type { LabsJourneyPackage } from "@shared/types/graphqlGenerated";
import { JourneyCheckoutPrice } from "@unauthenticated/signupSignin/components/JourneyCheckoutPrice/JourneyCheckoutPrice";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

interface Props {
  children: ReactNode;
  orderTotal: number;
  promotionalPrice?: LabsJourneyPackage["promotionalPrice"];
  isLoading?: boolean;
}

const JourneyMobileOrderSummary = ({
  children,
  orderTotal,
  promotionalPrice,
  isLoading = false,
}: Props) => {
  const { t } = useTranslation();
  const [accordion, setAccordion] = useState(false);

  const renderTotal = () => {
    if (isLoading) {
      return <Skeleton variant="typography" typographyType="body" width={5} />;
    }

    return <JourneyCheckoutPrice price={orderTotal} promotionalPrice={promotionalPrice} />;
  };

  return (
    <Accordion
      coreTriggerContent={
        <Typography variant="body">
          {t(
            accordion
              ? l.journeyCheckout.orderSummary.hideOrderSummary
              : l.journeyCheckout.orderSummary.showOrderSummary
          )}
        </Typography>
      }
      secondaryTriggerContent={renderTotal()}
      onChange={setAccordion}
      chevronPosition="start"
      isContentMarginless
    >
      {children}
    </Accordion>
  );
};

export { JourneyMobileOrderSummary };
